import { Component, Input, OnInit } from "@angular/core";
import { ScreenType } from "@fgb/portal-component-library/src/lib/directives";
import { MemberDetails, MemberQuery, MemberCard, MemberCardQuery } from "@fgb/core";
import { Observable } from "rxjs";

@Component({
  selector: "fgb-banner",
  templateUrl: "./banner.component.html",
  styleUrl: "./banner.component.scss",
})
export class BannerComponent implements OnInit {
  @Input() pageName: string;
  @Input() isHomePage: boolean = false;
  screenSize = ScreenType;
  memberDetails$: Observable<MemberDetails | undefined>;
  memberCard$: Observable<MemberCard | undefined>;

  constructor(
    private memberQuery: MemberQuery,
    private memberCardQuery: MemberCardQuery
  ) {}

  ngOnInit() {
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.memberCard$ = this.memberCardQuery.selectCurrentCard();
  }
}
